import React from 'react';
import { Button, Column, Row } from '@grubhubprod/gh-cookbook-react';
import { useForm, FormProvider } from 'react-hook-form/dist/index.ie11';
import { PeopleSearchInput } from 'src/components/oneCorp/features/MealCredit/common/formFields/TextInput/PeopleSearchInput';

export interface PeopleSearchFormProps {
  onSubmit: (query: string) => void;
}

export function PeopleSearchForm({
  onSubmit,
}: PeopleSearchFormProps): JSX.Element {
  const useFormProps = useForm({
    defaultValues: {
      query: '',
    },
    mode: 'onSubmit',
  });

  const { handleSubmit } = useFormProps;

  async function onPeopleSearchSubmit({ query }): Promise<void> {
    onSubmit(query);
  }

  return (
    <FormProvider {...useFormProps}>
      <form>
        <Row alignItems="center" gutter={8}>
          <Column phone={6} tablet={4} gutter={8}>
            <PeopleSearchInput name="query" id="peopleQuery" />
          </Column>
          <Column phone={6} tablet={2} gutter={8}>
            <Button
              type="submit"
              variant="primary"
              buttonSize="small"
              onClick={handleSubmit(onPeopleSearchSubmit)}
            >
              Search
            </Button>
          </Column>
        </Row>
      </form>
    </FormProvider>
  );
}
